import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { AnimationItem } from 'lottie-web/build/player/lottie_svg';
import { AnimationOptions } from 'ngx-lottie';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { AmandaOptions, AssetsSharedService } from 'shared/services/assets-shared.service';

import { PieceLottieSettings } from 'extensions/st/piece-lottie/front/models/piece-lottie.models';


@Component({
  selector: 'piece-lottie-render',
  templateUrl: './piece-lottie-render.component.html'
})
export class PieceLottieRenderComponent
  extends BaseRenderComponent<PieceLottieSettings>
  implements OnChanges {

  public options: AnimationOptions = {
    path: '',
    loop: true,
    autoplay: true
  };

  public animationItem?: AnimationItem;

  constructor(
    protected readonly renderConfigurationService: RenderConfigurationService,
    private readonly assetsSharedService: AssetsSharedService
  ) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.type === 'workspace') {
      this.setAnimationSettings(changes);
    } else if (this.type === 'render') {
      this.updateOptions();
    }
  }

  public animationCreated(animationItem: AnimationItem): void {
    this.animationItem = animationItem;
    this.animationItem.setSpeed(this.settings?.general?.speed);
  }

  public getAnimation(iconUrl: string): string | undefined {
    const assetsUrl = this.renderConfigurationService.config.assetsUrl;
    const akamaiOptions: AmandaOptions = { isWidthParamEnabled: false };

    return this.assetsSharedService.getAssetUrl(iconUrl, assetsUrl, akamaiOptions);
  }

  private setAnimationSettings(changes: SimpleChanges): void {
    if (changes.component) {
      const { previousValue, currentValue } = changes.component;
      const prevSettings = previousValue?.settings?.general;
      const currentSettings = currentValue?.settings?.general;
      if (currentSettings) {
        if (currentSettings.animationName && prevSettings?.animationName !== currentSettings.animationName) {
          this.options = {
            ...this.options,
            path: this.getAnimation(`lottie/${currentValue.settings?.general.animationName}.json`)
          };
        }
        if (this.animationItem && prevSettings?.speed !== currentSettings.speed) {
          this.animationItem.setSpeed(currentSettings.speed);
        }
        if (prevSettings?.effect !== currentSettings.effect) {
          this.options.loop = currentSettings.effect === 'loop';
        }
      }
    }
  }

  private updateOptions(): void {
    this.options = {
      ...this.options,
      path: this.getAnimation(`lottie/${this.settings?.general?.animationName}.json`),
      loop: this.settings?.general?.effect === 'loop'
    };
  }

}
